<!-- prettier-ignore -->

<div style="position: relative; width: 100%; height: 100%;">

  <img #lazyImage class="lazy-imag-card" draggable="false"
    [defaultImage]="'/assets/imgs/loader.svg'" 
    [errorImage]="urlFallback" 
    [lazyLoad]="url" 
    [alt]="altImage" 
    (error)="tools.onImageError($event)" 
  />
  
</div>